import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {useStyles} from '@wix/tpa-settings/react'
import {ALIGNMENT, ExperimentNames} from '@wix/wix-events-commons-statics'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {ChevronLeft, ChevronLeftSmall, DismissSmall, X} from '@wix/wix-ui-icons-common'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../../../../../stylesParams'
import s from './popup-header.scss'

interface PopupHeaderProps {
  text: string
  eventList?: boolean
  eventDetails?: boolean
  onClose: () => void
  onBack?: () => void
}

export const PopupHeader = ({text, eventList, eventDetails, onBack, onClose}: PopupHeaderProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const {get} = useStyles()

  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)

  const handleBackKeyDown = onBack ? handleKeyPressEnterOrSpace(onBack) : undefined

  const backClickHandler = onBack || (() => {})

  return calendarRevampEnabled ? (
    <div
      className={classNames(s.headerContainer, {
        [s.eventList]: eventList,
        [s.eventDetails]: eventDetails,
      })}
    >
      {!!onBack && (
        <div className={classNames(s.headerButton, s.back)} onClick={backClickHandler} onKeyDown={handleBackKeyDown}>
          <ChevronLeftSmall
            aria-label={t('a11y.calendarPopupBackButtonLabel')}
            role="button"
            tabIndex={0}
            data-hook={DH.calendarPopupBackButton}
          />
        </div>
      )}
      {!eventDetails && (
        <div
          data-hook="calendar-popup-title"
          className={classNames(s.title, {
            [s.titlePadding]: get(stylesParams.calendarPopupHorizontalAlignment) === ALIGNMENT.CENTER,
          })}
        >
          {text}
        </div>
      )}
      <div
        data-hook={DH.calendarPopupCloseButton}
        className={classNames(s.headerButton, s.close)}
        tabIndex={0}
        role="button"
        aria-label={t('a11y.close')}
        onClick={onClose}
        onKeyDown={handleKeyPressEnterOrSpace(onClose)}
      >
        <DismissSmall />
      </div>
    </div>
  ) : (
    <div>
      <div
        className={classNames(s.date, {
          [s.dateWithChevron]: onBack,
          [s.eventList]: eventList,
          [s.eventDetails]: eventDetails,
        })}
      >
        {!!onBack && (
          <div
            data-hook={DH.calendarPopupBackButton}
            className={s.dateChevron}
            tabIndex={0}
            onClick={backClickHandler}
            onKeyDown={handleBackKeyDown}
          >
            <ChevronLeft size="24px" />
          </div>
        )}
        <div
          data-hook="calendar-popup-title"
          className={s.dateText}
          onClick={backClickHandler}
          onKeyDown={handleBackKeyDown}
        >
          {text}
        </div>
      </div>
      <div
        data-hook={DH.calendarPopupCloseButton}
        className={s.close}
        tabIndex={0}
        role="button"
        aria-label={t('a11y.close')}
        onClick={onClose}
        onKeyDown={handleKeyPressEnterOrSpace(onClose)}
      >
        <X size="16px" />
      </div>
    </div>
  )
}
